import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class NotificationService {

    constructor(private api: ApiService) {}

    getNotifications() {
        return this.api.get(this.api.path + '/notification');
    }

    markRead(id: any) {
        return this.api.post(this.api.path + '/notification/' + id + '/read');
    }

    markAllRead() {
        return this.api.post(this.api.path + '/notification/read-all');
    }
}
